<template>
    <div class="pc-wrap">
        <CompHeader />
        <div class="wrap">
            <CompSide @scrollTop="scrollTop" :noSecond="true" />
            <div class="mian-box" ref="mainBox">
                <div class="main-cont">
                    <div class="main">
                        <router-view />
                    </div>
                    <CompFooter ref="Footer"/>
                    <CompFloating :show="show" @scrollTop="scrollTop"/>
                    <ComMessage></ComMessage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompHeader from './common/header'
import CompSide from './common/side'
import CompFooter from './common/footer'
import CompFloating from './common/floating'
import ComMessage from './common/message.vue'

export default {
    components: {
        CompHeader,
        CompSide,
        CompFooter,
        CompFloating,
        ComMessage
    },
    data() {
        return {
            show: false
        }
    },
    mounted() {
        const mainBox = this.$refs.mainBox
        mainBox.addEventListener('scroll', this.styleFun)
    },
    methods: {
        styleFun(e) {
            let top = e.target.scrollTop
            if (top > 90) {
                this.show = true
            } else {
                this.show = false
            }
        },
        scrollTop() {
            const mainBox = this.$refs.mainBox
            mainBox.scrollTo(0, 0)
        }
    }
}
</script>

<style lang="scss" scoped>
.pc-wrap {
    min-width: 1080px;
    min-height: 600px;
    height: 100%;
    background: #F2F2F2;

    .wrap {
        display: flex;
        height: calc(100vh - 70px);
        min-height: 530px;
        .mian-box {
            flex: 1;
            overflow-y: scroll;
            position: relative;
            height: 100%;
            .main-cont {
                display: flex;
                flex-direction: column;
                min-height: 100%;
            }
            .main {
                flex: 1;
                min-width: 1080px;
                padding: 20px 20px 0 0;
                background: #F2F2F2;
                position: relative;
                min-height: 510px;
                display: flex;
                flex-direction: column;
                &>:first-child{
                    flex: 1;
                    min-height: 500px;
                }
            }
        }
    }
}
</style>